<section class="horses-race">
    @if (fixture && selectedMarketTitle) {
        <div class="content-wrapper">
            <section class="greyhounds-race-participants">
                <section class="market-tab-bar-section">
                    <ds-tabs-group
                        fullWidthTabs="false"
                        size="small"
                        variant="horizontal"
                        scrollSpeed="fast"
                        [activeTab]="active.id"
                        [scrollable]="true"
                        (activeTabChanged)="setSelectedMarket($event)">
                        @for (tab of marketTabs; track tab.id) {
                            <ds-tab [name]="tab.id.toString()">
                                <ng-container *dsTabHeader>
                                    {{ tab.title }}
                                </ng-container>
                            </ds-tab>
                        }
                    </ds-tabs-group>
                    @if (showMarketHelp) {
                        <ms-market-help [optionGroup]="optionGroup" />
                    }
                    @if (isOptionBet && subMarkets.length && displayType === groupTypes.Regular) {
                        <section class="market-picker">
                            <ms-scroll-adapter [msScrollSelectedInView]="subSelectedMarketId">
                                <ul>
                                    @for (marketTitle of subMarkets; track marketTitle) {
                                        <li>
                                            <button
                                                ds-pill
                                                size="small"
                                                [attr.data-menu-item-id]="marketTitle.id"
                                                [selected]="marketTitle.id === subSelectedMarketId"
                                                (click)="setSelectSubMarket(marketTitle)">
                                                {{ marketTitle.title }}
                                            </button>
                                        </li>
                                    }
                                </ul>
                            </ms-scroll-adapter>
                        </section>
                    }
                </section>
                <div (swipeleft)="onSwipe('left')" (swiperight)="onSwipe('right')">
                    @if (!isOptionBet && isWinMarketSelected(selectedMarketTitle, marketViews.Win)) {
                        <ms-gh-win-market-participants [fixture]="fixture" [trackingSource]="trackingSource" [isNextRaces]="isNextRaces" />
                    }
                    @if (isOptionBet && (displayType === groupTypes.Wincast || displayType === groupTypes.Regular)) {
                        <ms-gh-derived-win-market-participants
                            [ngClass]="{ 'trap-winner': marketType === racingOptionMarketTypes.TrapWinner }"
                            [optionGroup]="optionGroup"
                            [displayType]="displayType"
                            [participantOptionGroups]="participantOptionGroups"
                            [greyhoundTrapDogMapping]="greyhoundTrapDogMapping"
                            [fixture]="fixture"
                            [selectedMarketTitle]="selectedMarketTitle"
                            [marketType]="marketType"
                            [optionPickTrackingsource]="getPickTrackingSource(sportTracking)" />
                    }
                    @if (isWinMarketSelected(selectedMarketTitle, marketViews.Forecast) || marketType === 'Forecast') {
                        <ms-horses-forecast
                            [mode]="'forecast'"
                            [isGreyhounds]="true"
                            [fixture]="fixture"
                            [selectTopTwo]="selectTopTwo"
                            [selectTopThree]="selectTopThree"
                            [optionGroup]="optionGroup"
                            [participantOptionGroups]="participantOptionGroups"
                            [greyhoundTrapDogMapping]="greyhoundTrapDogMapping"
                            [trackingSource]="trackingSource"
                            [msAutomation]="{ mode: 'forecast' }" />
                    }
                    @if (isWinMarketSelected(selectedMarketTitle, marketViews.Tricast) || marketType === 'Tricast') {
                        <ms-horses-forecast
                            [mode]="'tricast'"
                            [isGreyhounds]="true"
                            [fixture]="fixture"
                            [selectTopTwo]="selectTopTwo"
                            [selectTopThree]="selectTopThree"
                            [optionGroup]="optionGroup"
                            [participantOptionGroups]="participantOptionGroups"
                            [greyhoundTrapDogMapping]="greyhoundTrapDogMapping"
                            [trackingSource]="trackingSource"
                            [msAutomation]="{ mode: 'tricast' }" />
                    }
                    @if (isOptionBet && displayType === groupTypes.Outrights) {
                        <ms-horses-specials
                            [optionGroups]="optionGroups"
                            [isGreyhounds]="true"
                            [event]="fixture"
                            [selectedMarketId]="selectedMarketId"
                            [trackingSource]="getPickTrackingSource(sportTracking)"
                            [trackingOptions]="getPickTrackingOptions()" />
                    }
                </div>
            </section>
        </div>
    }
</section>
